import React from "react";
import { useSelector } from "react-redux";
import { Box, Typography, Button, Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";
import FolderOffIcon from "@mui/icons-material/FolderOff";

/**
 * ProjectRequired Component
 *
 * Wrapper component that checks if a project is selected.
 * If no project is selected, it shows a message asking user to select a project.
 * If a project is selected, it renders the children.
 *
 * Usage:
 * <ProjectRequired>
 *   <YourPageContent />
 * </ProjectRequired>
 */
const ProjectRequired = ({ children }) => {
  const navigate = useNavigate();
  const projectId = useSelector((state) => state.project.currentProjectId);
  const projectName = useSelector((state) => state.project.currentProjectName);

  // If no project selected, show message
  if (!projectId) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "60vh",
          p: 3,
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 5,
            textAlign: "center",
            maxWidth: 500,
            borderRadius: 2,
          }}
        >
          <FolderOffIcon
            sx={{
              fontSize: 80,
              color: "#ccc",
              mb: 2,
            }}
          />
          <Typography variant="h5" fontWeight={600} gutterBottom>
            No Project Selected
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            Please select a project from the Dashboard to view and manage its data.
          </Typography>
          <Button
            variant="contained"
            onClick={() => navigate("/dashboard")}
            sx={{
              backgroundColor: "#1976d2",
              "&:hover": {
                backgroundColor: "#1565c0",
              },
            }}
          >
            Go to Dashboard
          </Button>
        </Paper>
      </Box>
    );
  }

  // Project is selected, render children
  return children;
};

export default ProjectRequired;
